// Third Party Imports
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { get } from 'lodash';

// Relative Imports
import appActions from '../../actions/actions';
import webFormPageActions from '../../actions/webFormPage';
import WebformPage from './WebFormPage';
import { getDefaultCountryCode } from '../utils/createAccountUtil';
import { validateCountOfProperty } from '../../utils/validate';

function mapStateToProps(state) {
    return {
        translations: state.app.translations,
        authState: state.app.authState,
        preferredLocale: state.system.preferredLocale,
        environment: state.system.environment,
        recaptchaResp: get(state, 'app.wfRecaptchaResp', ''),
        emailAddress: get(state, 'webFormPage.emailAddress', ''),
        firstName: get(state, 'webFormPage.firstName', ''),
        lastName: get(state, 'webFormPage.lastName', ''),
        dialingCountryCode: get(state, 'webFormPage.dialingCountryCode', ''),
        countryDialingNumber: get(state, 'webFormPage.countryDialingNumber', ''),
        phoneNumber: get(state, 'webFormPage.phoneNumber', ''),
        numberOfProperty: get(state, 'webFormPage.numberOfProperty', ''),
        propertyCount: get(state, 'propertyCount', {}),
        companyName: get(state, 'webFormPage.companyName', ''),
        softwareName: get(state, 'webFormPage.softwareName', ''),

        emailError: get(state, 'webFormPage.emailError', ''),
        firstNameError: get(state, 'webFormPage.firstNameError', ''),
        lastNameError: get(state, 'webFormPage.lastNameError', ''),
        phoneNumberError: get(state, 'webFormPage.phoneNumberError', ''),
        propertyCountError: get(state, 'webFormPage.propertyCountError', ''),
        companyNameError: get(state, 'webFormPage.companyNameError', ''),

        enableCreateWebformContinueButton: get(state, 'webFormPage.enableCreateWebformContinueButton', false),
        serviceError: get(state, 'webFormPage.serviceError', ''),
        publicUuid: get(state, 'app.publicUuid', '-1'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        webFormPageActions: bindActionCreators(webFormPageActions, dispatch),
        appActions: bindActionCreators(appActions, dispatch),
        dispatch
    };
}

@connect(mapStateToProps, mapDispatchToProps)
export default class WebFormPageContainer extends React.Component {
    constructor(props) {
        super(props);

        this.handlePropertyCountChange = this.handlePropertyCountChange.bind(this);
        this.onEmailBlur = this.onEmailBlur.bind(this);
        this.showOnFieldBlur = this.showOnFieldBlur.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleAlertDismiss = this.handleAlertDismiss.bind(this);
        this.setDialingCountryCode = this.setDialingCountryCode.bind(this);
        this.setPhoneNumber = this.setPhoneNumber.bind(this);

        this.handleFormOnchangeHandler = this.handleFormOnchangeHandler.bind(this);
        this.handleFieldValOnBlur = this.handleFieldValOnBlur.bind(this);
        this.triggerEdapEventOnFocus = this.triggerEdapEventOnFocus.bind(this);
        this.triggerEdapEventOnPhoneFocus = this.triggerEdapEventOnPhoneFocus.bind(this);
        this.triggerEdapPageViewAction = this.triggerEdapPageViewAction.bind(this);
        this.onCaptchaChange = this.onCaptchaChange.bind(this);
        this.setRecaptchaRef = this.setRecaptchaRef.bind(this);
    }

    componentWillMount() {
        const { authState, preferredLocale } = this.props;
        this.props.webFormPageActions.setField('dialingCountryCode', getDefaultCountryCode(preferredLocale));
        this.props.appActions.enableLoadOverLay(false);
        if (authState) {
            this.props.webFormPageActions.getWebformMetadata();
        }

    }

    componentDidMount() {
        window.recaptchaOptions = {
            lang: this.props.preferredLocale
        };
    }

    componentWillReceiveProps(nextProps) {
        this.onRecaptchaRespChange(nextProps);
        this.setDefaultCountryDialingNumber(nextProps);
    }

    onRecaptchaRespChange(nextProps) {
        if (!this.props.recaptchaResp && nextProps.recaptchaResp) {
            this.submitWebForm(nextProps.recaptchaResp);
        }
    }

    onCaptchaChange(response) {
        this.props.appActions.setCaptchaResponse('wf', response);
    }

    setDefaultCountryDialingNumber(nextProps) {
        if (!this.props.enableCreateWebformContinueButton && nextProps.enableCreateWebformContinueButton) {
            this.props.webFormPageActions.setField('countryDialingNumber', this.inputTel.state.phoneCode);
        }
    }

    triggerEdapEventOnFocus(event) {
        this.props.appActions.triggerEdapEvent('generic.event', {
            eventcategory: event.target.name,
            eventaction: `Focus on input field:${event.target.name}`,
            highfrequency: 'true'
        }, {});
    }

    triggerEdapEventOnPhoneFocus() {
        this.props.appActions.triggerEdapEvent('generic.event', {
            eventcategory: 'Phone',
            eventaction: 'Focus on Phone field',
            highfrequency: 'true'
        }, {});
    }

    triggerEdapPageViewAction() {
        this.props.appActions.triggerEdapPageView(this.props.publicUuid, 'Webform Page');
    }

    setDialingCountryCode(event, countryData) {
        this.props.webFormPageActions.setField('dialingCountryCode', countryData.cc);
        this.props.webFormPageActions.setField('countryDialingNumber', countryData.phoneCode);
        this.props.webFormPageActions.toggleContinueButton();
    }

    setPhoneNumber(event, phoneObject) {
        this.props.webFormPageActions.setField('phoneNumber', phoneObject.raw);
        this.props.webFormPageActions.toggleContinueButton();
        if (phoneObject.raw) {
            this.setFieldsError('phoneNumber');
        }
    }

    handlePropertyCountChange(event) {
        if(validateCountOfProperty(event.target.value)) {
            event.preventDefault();
            this.setPropertyCount(event.target.value);
        }
    }

    setPropertyCount(propertyCount) {
        event.preventDefault();
        this.setFieldsError('numberOfProperty');
        this.props.webFormPageActions.setField('numberOfProperty', propertyCount);
        this.props.webFormPageActions.toggleContinueButton();
    }

    handleFormOnchangeHandler(event) {
        if (event.target.id !== 'softwareName') {
            this.setFieldsError(event.target.id);
        }
        this.props.webFormPageActions.setField(event.target.id, event.target.value);
        this.props.webFormPageActions.toggleContinueButton();
    }

    onEmailBlur(event) {
        event.preventDefault();
        this.props.webFormPageActions.validateEmail(this.props.emailAddress);
    }

    showOnFieldBlur(event) {
        event.preventDefault();
        this.props.webFormPageActions.validatePropertyField(this.props.numberOfProperty);
    }

    handleFieldValOnBlur = (event) => {
        this.props.webFormPageActions.handleFieldValOnBlur(event.target.id, event.target.value);
    };

    setFieldsError(errorField) {
        const fields = [
            'emailAddress',
            'firstName',
            'lastName',
            'phoneNumber',
            'numberOfProperty',
            'companyName'

        ];

        for (const fieldVal of fields) {
            if (fieldVal === errorField) {
                this.props.webFormPageActions.setFieldError(fieldVal, '');
                break;
            }

            if (((fieldVal === 'emailAddress' && !this.props.emailAddress)
                || fieldVal === 'firstName' && !this.props.firstName)
                || (fieldVal === 'lastName' && !this.props.lastName)
                || (fieldVal === 'phoneNumber' && !this.props.phoneNumber)
                || (fieldVal === 'numberOfProperty' && !this.props.numberOfProperty)
                || (fieldVal === 'companyName' && !this.props.companyName)) {
                this.props.webFormPageActions.setFieldError(fieldVal, 'ipmob.input.field.required');
            }
        }
    }

    handleFormSubmit() {
        this.recaptchaRef.execute();
    }

    submitWebForm(recaptchaResp) {
        const leadFormUserInfo = {
            data : {
                firstName: this.props.firstName,
                lastName: this.props.lastName,
                companyName: this.props.companyName,
                contact : {
                    phone: {
                        countryCode: this.props.countryDialingNumber,
                        number: this.props.phoneNumber
                    }
                },
                propertyCount: this.props.numberOfProperty,
                emailAddress: this.props.emailAddress,
                propertyManagementSoftware: this.props.softwareName
            },
            recaptchaResp
        };
        this.props.webFormPageActions.createWebformAccount(leadFormUserInfo);
        this.props.appActions.enableLoadOverLay(true);
        this.props.appActions.triggerEdapEvent('generic.click', {
            eventcategory: 'Create Webform Page Account'
        }, {});
        this.props.appActions.setCaptchaResponse('wf', '');
        this.recaptchaRef.reset();
    }

    handleAlertDismiss() {
        this.props.webFormPageActions.alertError('');
    }

    getInputTel = (ref) => {
        this.inputTel = ref;
    }

    setRecaptchaRef = (ref) => {
        this.recaptchaRef = ref;
    }

    render() {
        return (
            <WebformPage
                translations={this.props.translations}
                environment = {this.props.environment}
                emailError={this.props.emailError}
                emailVal={this.props.emailAddress}
                handleEmailBlur={this.onEmailBlur}

                firstNameError={this.props.firstNameError}
                firstNameVal={this.props.firstName}

                lastNameError={this.props.lastNameError}
                lastNameVal={this.props.lastName}

                handlePropertyCountChange={this.handlePropertyCountChange}
                numberOfProperty={this.props.numberOfProperty}
                propertyCountError={this.props.propertyCountError}
                onPropertyCountBlur={this.showOnFieldBlur}

                countryCodeVal={this.props.dialingCountryCode}
                phoneNumberVal={this.props.phoneNumber}
                phoneNumberError={this.props.phoneNumberError}
                handlePhoneNumberChange={this.setPhoneNumber}
                handleCountryCodeChange={this.setDialingCountryCode}

                companyNameVal={this.props.companyName}
                companyNameError={this.props.companyNameError}

                softwareNameVal={this.props.softwareName}

                handleFormSubmit={this.handleFormSubmit}
                enableButton={this.props.enableCreateWebformContinueButton}

                handleFormOnchangeHandler={this.handleFormOnchangeHandler}
                handleFieldValOnBlur={this.handleFieldValOnBlur}
                triggerEdapPageViewAction={this.triggerEdapPageViewAction}
                triggerEdapEventOnFocus={this.triggerEdapEventOnFocus}
                triggerEdapEventOnPhoneFocus={this.triggerEdapEventOnPhoneFocus}
                handleAlertDismiss={this.handleAlertDismiss}
                serviceError={this.props.serviceError}
                getInputTel={this.getInputTel}
                onCaptchaChange={this.onCaptchaChange}
                setRecaptchaRef={this.setRecaptchaRef}
            />
        );
    }
}

WebFormPageContainer.propTypes = {

    emailAddress: PropTypes.string,
    emailError: PropTypes.string,

    firstName: PropTypes.string,
    firstNameError: PropTypes.string,

    lastName: PropTypes.string,
    lastNameError: PropTypes.string,

    numberOfProperty: PropTypes.string,
    propertyCountError: PropTypes.string,

    dialingCountryCode: PropTypes.string,
    countryDialingNumber: PropTypes.string,
    phoneNumber: PropTypes.string,
    phoneNumberError: PropTypes.string,

    companyName: PropTypes.string,
    companyNameError: PropTypes.string,

    softwareName: PropTypes.string,

    enableCreateWebformContinueButton: PropTypes.bool,
    serviceError: PropTypes.string,

    publicUuid: PropTypes.string,
    recaptchaResp: PropTypes.string,
};

WebFormPageContainer.defaultProps = {

    emailAddress: '',
    emailError: '',

    firstName: '',
    firstNameError: '',

    lastName: '',
    lastNameError: '',

    dialingCountryCode: '',
    countryDialingNumber: '',
    phoneNumber: '',
    phoneNumberError: '',

    numberOfProperty: '',
    propertyCountError: '',

    companyName: '',
    companyNameError: '',

    softwareName: '',
    softwareNameError: '',

    enableCreateWebformContinueButton: false,
    serviceError: '',

    publicUuid: '-1',
    recaptchaResp: ''
};
